import React from 'react';
import PropTypes from 'prop-types';
import ConnectedUserManager from './ConnectedUserManager';

const UserManagerRouting = ({ match }) => <ConnectedUserManager />;

UserManagerRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default UserManagerRouting;
